((($) => {
    const onChangeCity = (selectedCity) => {
        localStorage.setItem('weather_city', selectedCity);

        $.each($('.weather-wrapper'), function (index, _wrapper) {

            const city = $(_wrapper).find('.weather-cities-list').first();
            const cityData = city.find(`[value="${selectedCity}"]`);
            city.val(selectedCity);

            const dataTempDest = $(_wrapper).find(city.data('temp_dest'));
            const iconDest = $(_wrapper).find(city.data('icon_dest'));
            const highDest = $(_wrapper).find(city.data('high_dest'));
            const lowDest = $(_wrapper).find(city.data('low_dest'));

            if (dataTempDest.length) {
                dataTempDest.html(cityData.data('temp'));
            }
            if (iconDest.length) {
                iconDest.html(`<i class="${cityData.data('icon')}"></i>`);
            }
            if (highDest.length) {
                highDest.html(cityData.data('high'));
            }
            if (lowDest.length) {
                lowDest.html(cityData.data('low'));
            }

        });

    }

    $.each($('.weather-wrapper'), function (index, _wrapper) {
        const city = $(_wrapper).find('.weather-cities-list').first();
        city.on('change', function (e) {
            const val = $(this).val();
            onChangeCity(val);
        })
    })

    if (null !== localStorage.getItem('weather_city') && undefined !== localStorage.getItem('weather_city') && localStorage.getItem('weather_city')) {
        onChangeCity(localStorage.getItem('weather_city'));
    }

})(jQuery));



// WEBPACK FOOTER //
// ./src/scripts/weather.js